import React from 'react';
import { useLocation } from 'react-router-dom';
import { getNavIcon } from './DashboardLayout';

/**
 * The icon+title pairing used at the top of every dashboard page — same
 * icon as that page's nav entry, same layout everywhere. Jenn, 2026-08-27:
 * "Each page should have its icon next to the title... it should be
 * consistent across the pages." Auto-looks up the icon from the current
 * route by default; pass `path` to override (e.g. a page reachable from
 * more than one nav entry).
 */
export default function PageHeading({ title, subtitle, path, className = '' }) {
  const location = useLocation();
  const { iconImg, icon } = getNavIcon(path || location.pathname);

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {(iconImg || icon) && (
        <span className="w-11 h-11 shrink-0 flex items-center justify-center">
          {iconImg
            ? <img src={iconImg} alt="" className="w-11 h-11 object-contain" />
            : <span className="text-4xl leading-none">{icon}</span>}
        </span>
      )}
      <div className="min-w-0">
        <h1 className="font-serif text-2xl font-bold text-reset-brown">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
    </div>
  );
}
